module.exports = __webpack_public_path__ + "static/img/treasure.30903ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team/treasure.png
// module id = 278
// module chunks = 6